export default {
  PLAYER: 'player',
  PLAYER_WITH_ARTICLE: 'player.with.article',
  PLAYER_WITH_FALLBACK: 'player.with.fallback',
};
